import React from 'react';
import { Meteor } from 'meteor/meteor';
import { Route, Link } from 'react-router';

import { Roles } from 'roles';
import { Tracker } from 'meteor/tracker';

import { MontgolfiereSchema, Montgolfieres } from '../../collections/montgolfieres/montgolfieres';
import { Reactive } from '../common/Reactive.mixin.js';

import {
  Well,
  Table,
  Button,
  Breadcrumb,
  Col,
  BPanel
} from '@sketchpixy/rubix';

import MgfTableComponent from '../common/mgfTable';

@Reactive({
	subscriptions: ["montgolfieres"],
})
export default class MontgolfiereListPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			archived: false,
			montgolfieres: []
		};

		props.ready.then(() => {
			Tracker.autorun(() => {
				this.setState({
					'montgolfieres' : Montgolfieres.find({archived: {$ne: true}}, {sort: {id: -1}}).fetch(),
				});
			});
		});
	}

	toggleArchived() {
		this.setState({
			archived: !this.state.archived
		});

		console.log('achived', this.state.archived);
		if(!this.state.archived) {
			this.setState({
				'montgolfieres' : Montgolfieres.find({archived: true}, {sort: {id: -1}}).fetch(),
			});
		} else {
			this.setState({
				'montgolfieres' : Montgolfieres.find({archived: {$ne: true}}, {sort: {id: -1}}).fetch(),
			});
		}
	}

	render() {

		return (
			<div>
				<Breadcrumb>
					<Breadcrumb.Item>
						Montgolfieres
					</Breadcrumb.Item>
					<Breadcrumb.Item active>
						Liste des montgolfieres
					</Breadcrumb.Item>
					<Breadcrumb.Item>
						{ Roles.userHasPermission(Meteor.userId(), 'montgolfieres.insert') &&
							<Link to="/montgolfieres/add"><Button bsStyle="success">Ajouter</Button></Link> }
					</Breadcrumb.Item>
				</Breadcrumb>
				<Button bsStyle="primary" onClick={this.toggleArchived.bind(this)}>{!this.state.archived ? <p>Voir les montgolfieres archivées</p> : <p>Voir les montgolfieres actives</p>}</Button><br/><br/>
				<BPanel header="Liste des montgolfieres">
					{ this.props.isReady &&
						<MgfTableComponent fields={MontgolfiereSchema._schema} list={this.state.montgolfieres} type='montgolfieres'></MgfTableComponent> }
				</BPanel>
			</div>
		);
	}
}

MontgolfiereListPage.propTypes = {
  montgolfieres: React.PropTypes.array.isRequired,
};




/** WEBPACK FOOTER **
 ** ./src/universal/components/montgolfieres/MontgolfiereList.page.js
 **/